import { render, staticRenderFns } from "./ShowCompanyInfo.vue?vue&type=template&id=08ee4870&"
import script from "./ShowCompanyInfo.vue?vue&type=script&lang=ts&"
export * from "./ShowCompanyInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports